import { apiGet, apiPost } from './apiClient';

export interface ScreeningMatch {
  id: string;
  screening_id: string;
  matched_entity_name: string;
  matched_entity_type: string;
  match_score: number;
  source: string;
  match_details: Record<string, any>;
  status: string;
  resolved_by: string | null;
  resolved_at: string | null;
  resolution_notes: string | null;
}

export interface ScreeningResult {
  id: string;
  investor_id: string;
  investor_name: string;
  screening_date: string;
  match_count: number;
  highest_score: number;
  status: string;
  screened_by: string;
  matches: ScreeningMatch[];
  next_rescreening_date: string | null;
  created_at: string;
}

export interface ScreeningStats {
  total_screened: number;
  matches_found: number;
  false_positives: number;
  pending_review: number;
  pending_rescreening: number;
}

export const screeningService = {
  screenInvestor: (investorId: string) =>
    apiPost<ScreeningResult>(`/screening/investor/${investorId}`),

  getResults: (investorId?: string, status?: string) =>
    apiGet<ScreeningResult[]>('/screening/results', {
      params: { investor_id: investorId, status },
    }),

  resolveMatch: (matchId: string, resolution: string, notes: string) =>
    apiPost<ScreeningMatch>(`/screening/matches/${matchId}/resolve`, {
      is_false_positive: resolution === 'false_positive',
    }),

  getPendingRescreening: () =>
    apiGet<ScreeningResult[]>('/screening/pending-rescreening'),

  bulkRescreen: (investorIds: string[]) =>
    apiPost<ScreeningResult[]>('/screening/bulk-rescreen', { investor_ids: investorIds }),

  getStats: () =>
    apiGet<ScreeningStats>('/screening/stats'),
};
